import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './axios'
import Vant from 'vant'
import common from './common/common.js'
import role from './common/role.js'

import VueLazyload from 'vue-lazyload'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import Antd from 'ant-design-vue'

import VueUeditorWrap from 'vue-ueditor-wrap'
import vcolorpicker from 'vcolorpicker'

import 'vue2-animate/dist/vue2-animate.min.css'
import 'vant/lib/index.css'

import './assets/css/common.css'
import './assets/css/style.css' 
import './assets/css/jquery-weui/dist/lib/weui.min.css'
import './assets/css/jquery-weui/dist/css/jquery-weui.min.css'
import './assets/css/jquery-weui/demos/css/demos.css'
import 'ant-design-vue/dist/antd.css'
import filter from './common/filter'


Object.keys(filter).forEach((v,i)=>{
Vue.filter(v,filter[v]);
})

Vue.use(Vant)
Vue.config.productionTip = false
Vue.use(Antd)

Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.use(vcolorpicker)
Vue.use(VueLazyload, {
preLoad: 1.3,


attempt: 1,
listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
})
Vue.prototype.$http = axios
Vue.prototype.$role = role
Vue.prototype.$common = common

Vue.component('qrcode', Qrcode)
Vue.config.productionTip = false








global.HTTP = 'https://psapi.songjianxia.com/admin/v2/'
global.HTTP_ADMIN = 'https://sss-admin-go-api.51sssong.com/' 


global.HTTPMobile = 'https://psapi.songjianxia.com'
/* eslint-disable no-new */
if(window.location.host.indexOf('d2')!=-1){
global.HTTP = 'https://psapi2.songjianxia.com/admin/v2/'
global.HTTPMobile = 'https://psapi2.songjianxia.com'
}
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})
console.log(window)


// WEBPACK FOOTER //
// ./src/main.js